import { render, staticRenderFns } from "./EditBookmark.vue?vue&type=template&id=3435b668&"
import script from "./EditBookmark.vue?vue&type=script&lang=js&"
export * from "./EditBookmark.vue?vue&type=script&lang=js&"
import style0 from "./EditBookmark.vue?vue&type=style&index=0&id=3435b668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports